import React from 'react'
import {
  Chip, ChipProps, styled
} from '@mui/material'

const StyledChip = styled(Chip)({
  height: '24px',
  '& .MuiChip-label': {
    fontWeight: '700',
    fontSize: '10px',
    padding: '0 8px'
  }
})

const CustomChip: ReactFC<ChipProps> = (props) => {
  return <StyledChip {...props} />
}
export default CustomChip
